import { getCity } from '@src/containers/Session/selectors/getCity';
import { createSelector } from 'reselect';

export const loadStrapiSFUParams = createSelector(getCity, (city) => {
	const { id: cityId } = city;
	return {
		cityGorkoId: cityId || null,
	};
});
